import { render, staticRenderFns } from "./modal-form-sort.vue?vue&type=template&id=b926bbee&"
import script from "./modal-form-sort.vue?vue&type=script&lang=js&"
export * from "./modal-form-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports